export const getEnvVar = <Key extends keyof ImportMetaEnv>(key: Key, optional = false) => {
	if (!optional && import.meta.env[key] === undefined) {
		throw new Error(`Env variable ${key} is required`)
	}
	const result = import.meta.env[key]

	if (result === 'true') return true
	if (result === 'false') return false

	// eslint-disable-next-line @typescript-eslint/no-unsafe-return
	return result ?? undefined
}
